import { cn } from "@/lib/utils";

export const OutletContainer = ({
	className,
	children,
}: { className?: string; children: React.ReactNode }) => {
	return <div className={cn("px-4 md:p-8", className)}>{children}</div>;
};
